import { Module, ModuleVariantsType } from '../../types'

export const createGroupCardProjectDesktopConfiguration = (): Module[] => {
  return [
    {
      __typename: 'ModuleTwoColumn',
      left: [
        { __typename: 'ModuleImages' },
        { __typename: 'ModulePeopleAlsoViewed' },
      ],
      right: [
        {
          __typename: 'ModuleVariants',
          type: ModuleVariantsType.RADIO,
        },
        { __typename: 'ModuleDispatch' },
        { __typename: 'ModuleButtons' },
        { __typename: 'ModuleMoreInfo' },
      ],
    },
  ]
}
